import {ConfigText} from 'components/common/ConfigText'
import {ContactInfo} from 'components/common/ContactsInfo'
import {Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getDiscountDetails} from 'utils/getDiscountDetails'

type Props = {
  order: Ventrata.Order
}

export const OrderInfo = ({order}: Props) => {
  const discountDetails = getDiscountDetails(order)

  return (
    <div className="p-4 bg-white rounded-lg flex flex-col divide-solid divide-y divide-gray-4">
      <div className="text-xl font-semibold pb-4">Order #{order.supplierReference}</div>
      {order.contact.fullName && <ContactInfo contact={order.contact} className="py-4" />}
      <div className="py-4">
        <div className="flex justify-between">
          <div>
            <ConfigText configKey="activitiesLabel" defaultText="Activities" /> x {order.bookings.length}
          </div>
          <div>{formatMoney(order.pricing?.original, order.pricing?.currency)}</div>
        </div>
        {discountDetails && (
          <div className="flex justify-between">
            <div>{discountDetails.name}</div>
            <div>– {formatMoney(discountDetails.value, order.pricing?.currency)}</div>
          </div>
        )}
      </div>

      <div className="pt-4 flex justify-between">
        <div className="text-lg font-bold">Total</div>
        <div className="text-lg font-bold">{formatMoney(order.pricing?.retail, order.pricing?.currency)}</div>
      </div>
    </div>
  )
}
